import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Box,
  IconButton,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

interface BroadcastDialogProps {
  open: boolean
  onClose: () => void
  onComplete: () => void
}

const BroadcastDialog: React.FC<BroadcastDialogProps> = ({ open, onClose, onComplete }) => {
  const [formData, setFormData] = useState({
    recipients: 'all',
    message: '',
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false)
      setFormData({ recipients: 'all', message: '' })
      onComplete()
    }, 1000)
  }

  const handleClose = () => {
    if (!isLoading) {
      setFormData({ recipients: 'all', message: '' })
      onClose()
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Broadcast Message
          <IconButton onClick={handleClose} disabled={isLoading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            select
            fullWidth
            name="recipients"
            label="Recipients"
            value={formData.recipients}
            onChange={handleChange}
            sx={{ mb: 3 }}
          >
            <MenuItem value="all">All Leads</MenuItem>
            <MenuItem value="qualified">Qualified Leads</MenuItem>
            <MenuItem value="new">New Leads</MenuItem>
          </TextField>
          
          <TextField
            fullWidth
            multiline
            rows={4}
            name="message"
            label="Message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Enter your broadcast message..."
            required
          />
        </DialogContent>
        
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={isLoading || !formData.message.trim()}
          >
            {isLoading ? 'Sending...' : 'Send Broadcast'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default BroadcastDialog
